import { CoreIcon } from '../core-icon';
import cardFillSVG from '../../assets/icons/card-fill.svg';
import type { IconProps } from '../core-icon';

export const CardFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={cardFillSVG} {...props} />;
};
